import React, { Component } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Result from "./Result.jsx";
import "../style/exercices.css";
import { success, fail } from "../utils/coursesUtils.js";
import { withTranslation } from "react-i18next";
import { globalT } from "../utils/globalUtils.js";

class ExAbc extends Component {
  constructor(props) {
    super(props);
    this.audioRef = React.createRef();

    this.state = {
      list: this.props.el.list,
      correctOption: this.props.el.correct,
      result: false,
      finished: false,
      activeOptionId: null,
      showButton: false,
      soundType: "false",
    };
  }

  setActiveOption = (optionId) => {
    this.setState({ activeOptionId: optionId });
    this.setState({ showButton: true });
  };

  checkResults = () => {
    const correctOption = this.state.correctOption;
    const activeOptionId = this.state.activeOptionId;

    const result = correctOption === activeOptionId;

    this.setState({ result, finished: true }, () => {
      if (result) {
        success(this);
      } else {
        fail(this);
      }
      const body = document.querySelector("#content");
      body.scrollTo(0, 0);
    });
  };

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.soundType !== this.state.soundType) {
  //     // Actualiza la referencia al elemento de audio cuando cambia soundType
  //     this.audioRef.current.src = `/sounds/${this.state.soundType}`;
  //   }
  // }

  render() {
    const { el, genre } = this.props;
    const { t } = this.props;
    const props = this.props;
    const {
      list,
      result,
      finished,
      correctOption,
      activeOptionId,
      showButton,
    } = this.state;

    return (
      <div>
        <div className="m-breadcrumb">
          <div className="m-genre">{genre}</div>
          <div className="m-exTitle">{el.typeName}</div>
        </div>
        <div
          className={`m-exercice ${finished ? "finished" : ""}`}
          data-type="abc"
        >
          {finished && <Result result={result} />}
          {el.title && (
            <div
              className="m-title"
              dangerouslySetInnerHTML={{ __html: el.title }}
            ></div>
          )}{" "}
          {el.subtitle && (
            <div
              className="m-subtitle"
              dangerouslySetInnerHTML={{ __html: el.subtitle }}
            ></div>
          )}
          {el.title2 && (
            <div
              className="m-title"
              dangerouslySetInnerHTML={{ __html: el.title2 }}
            ></div>
          )}
          <div
            className="m-abcOptions"
            id="abcOptions"
            data-correct={correctOption}
          >
            {list?.map((item) => (
              <div
                className={`m-option ${
                  item.id === activeOptionId ? "active" : ""
                } ${
                  finished && !result && item.id === activeOptionId
                    ? "m-incorrect"
                    : ""
                }`}
                id={`option` + item.id}
                key={item.id}
                onClick={() => this.setActiveOption(item.id)}
                dangerouslySetInnerHTML={{ __html: item.text }}
              >
                {/* {item.text} */}
              </div>
            ))}
          </div>
          {el.font && (
            <div className="m-font">
              {globalT("FUENTE DEL TEXTO")}{" "}
              {el.adaptedSRC && <span>{`(${globalT("adaptado")})`}</span>}:{" "}
              <a href={el.font} target="_blank" rel="noreferrer">
                {el.font}
              </a>
            </div>
          )}
          <div className="m-buttons">
            {finished ? (
              <button
                className="m-button"
                id="buttonBack"
                onClick={() => {
                  const path = props.location.pathname;
                  const parentPath = path.substring(0, path.lastIndexOf("/"));
                  props.navigate(parentPath + "/");
                }}
              >
                <span>{globalT("vuelve a las actividades")}</span>
              </button>
            ) : (
              <button
                className={`m-button ${!showButton && "disabled"}`}
                onClick={this.checkResults}
              >
                <span>{globalT("Continúa")}</span>
              </button>
            )}
          </div>
          <audio ref={this.audioRef} src=""></audio>
        </div>
      </div>
    );
  }
}

function ExAbcWrapper(props) {
  const navigate = useNavigate();
  const location = useLocation();
  return <ExAbc {...props} navigate={navigate} location={location} />;
}

export default withTranslation()(ExAbcWrapper);
